export enum PumpSensorNameEnum {
  CIR_PUMP = 'Zirkulationspumpe ',
  ROOM_PUMP = 'Heizkreispumpe ',
  BUFFER_PUMP = 'Pufferladepumpe ',
  BOILER_PUMP = 'Kesselkreispumpe ',
  SOLAR_PUMP_PRIMARY = 'Solarpumpe Primär ',
  SOLAR_PUMP_SECONDARY = 'Solarpumpe Sekundär ',
  HOT_WATER_CHARGING_PUMP = 'Boilerladepumpe ',
  HEAT_PUMP = 'Wärmepumpe ',
  WARM_WATER_PUMP = 'Warmwasserpumpe ',
}
